import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    axios.get(`${API}/settings/public`).then(({ data }) => {
      const id = data.ga_id;
      if (!id || window.__gaLoaded) return;
      window.__gaLoaded = id;
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', id, { send_page_view: true });
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (window.gtag && window.__gaLoaded) {
      window.gtag('event', 'page_view', { page_path: location.pathname + location.search, page_location: window.location.href });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;
